exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".courtVedio .title[data-v-733883c2]{line-height:50px;padding-left:10px;border-bottom:1px solid #ccc}.courtVedio .content[data-v-733883c2]{width:100%;margin-top:15px}.courtVedio .footer[data-v-733883c2]{width:100%;margin-top:20px;text-align:center;height:100px}\n", ""]);

// exports
